import { Routes } from '@angular/router';
import { OnboardingComponent } from './onboarding.component';

export default [
    {
        path     : '',
        component: OnboardingComponent,
    },
    
] as Routes;
